var SCM = SCM || {};

SCM.IssueCovers = (function ($) {

    var viewCoverImageLinkString = '.js-cover-image-click';
    var $largeCoverImageWrap;
    var $largeCoverImage;
    var $largeCoverImageCaptionWrap;
    var $largeCoverImageCaptionText;

    return {
        init: init
    };

    // returns true if the feature is enabled, false otherwise
    function init() {

        if ($(viewCoverImageLinkString).length) {

            $largeCoverImageWrap = $('.js-cover-view-large');
            $largeCoverImage = $('.js-cover-view-large-img');
            $largeCoverImageCaptionWrap = $('.js-cover-view-large-caption-wrap');
            $largeCoverImageCaptionText = $('.js-cover-view-large-caption-text');

            $('.widget-IssueCoverBrowse').on('click', viewCoverImageLinkString, showCoverImage);
            return true;
        }

        return false;
    }

    function showCoverImage() {
        var $this = $(this);

        $largeCoverImage.attr('src', '');
        $largeCoverImage.attr('src', $this.attr('data-src'));

        if ($this.attr('data-caption').length) {
            $largeCoverImageCaptionWrap.removeClass('hide');
            $largeCoverImageCaptionText.html($this.attr('data-caption'));
        }
        else {
            $largeCoverImageCaptionWrap.addClass('hide');
        }

        $('body').addClass('on-canvas');
        $largeCoverImageWrap.addClass('open');
    }
})(jQuery);

jQuery(function () {
    SCM.IssueCovers.init();
});